<div class="overlay" [class.active]="isOpen" (click)="onClose()"></div>

<div class="thankyou-popup thankyou-popup_pos" [class.active]="isOpen">
  <div class="thankyou-popup__icon-wrapper">
    <img src="assets/img/icons/success.svg" alt="Thank you modal:Success icon" class="thankyou-popup__icon" />
  </div>

  <h3 class="thankyou-popup__title">{{ title }}</h3>

  <p class="thankyou-popup__description">{{ text }}</p>

  <button class="btn btn_soft thankyou-popup__button" (click)="onClose()">
    {{ buttonText }}
  </button>
</div>
